var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSquare = function SvgSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 10,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(14, 14, 15, 1)",
    d: "M0 0h10v10H0z"
  })));
};
export { SvgSquare as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgcm9sZT0iaW1nIiB3aWR0aD0iMTAiIGhlaWdodD0iMTAiPgogIDxyZWN0IGZpbGw9InJnYmEoMTQsIDE0LCAxNSwgMSkiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCI+PC9yZWN0Pgo8L3N2Zz4=";